import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orderIdToOpen: null, // when set, GlobalOrderDetailModal opens order details (any role / route)
};

const orderModalSlice = createSlice({
  name: 'orderModal',
  initialState,
  reducers: {
    setOrderIdToOpen: (state, action) => {
      state.orderIdToOpen = action.payload;
    },
    clearOrderIdToOpen: (state) => {
      state.orderIdToOpen = null;
    },
  },
});

export const { setOrderIdToOpen, clearOrderIdToOpen } = orderModalSlice.actions;
export default orderModalSlice.reducer;
